import { View } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import { waitFor } from '../lib/util/waitFor';

export default class Match2PopupSubHeader extends LangBitmapFontTextView {
  private decorators: View[] = [];

  constructor({
    superview,
    localeText,
    x,
    y,
    color,
  }: {
    superview: View;
    localeText: () => string;
    x?: number;
    y?: number;
    color?: string;
  }) {
    const defaultColor = '#7A674F';

    super({
      superview,
      localeText,
      x,
      y,
      font: 'Body',
      color: color ?? defaultColor,
      size: 26,
      centerOnOrigin: true,
      centerAnchor: true,
      verticalAlign: 'center',
      align: 'center',
    });

    // TODO: Resolve this hack for getting correct text dimensions
    waitFor(100).then(() => this.createDecorators(color ?? defaultColor));
  }

  private createDecorators(color: string) {
    const width = 49;
    const height = 3;

    for (let index = 0; index < 2; index++) {
      const decorator = new View({
        superview: this,
        backgroundColor: color,
        width,
        height,
        anchorX: width * (index === 0 ? -1 : 1),
        anchorY: height * 0.5,
        offsetX: width * (index - 1),
        offsetY: this.getTextHeight() * 0.5,
      });
      this.decorators.push(decorator);
    }

    this.positionDecorators();
  }

  private positionDecorators() {
    this.decorators.forEach((decorator, i) => {
      decorator.style.x = (this.getTextWidth() * 0.5 + 16) * (i === 0 ? -1 : 1);
    });
  }

  public override notifyLocaleTextChanged() {
    super.notifyLocaleTextChanged();
    this.positionDecorators();
  }
}
